import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SafetyMansioniService {
    static getAll = () => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/mansioni`;
        return ApiService.getRudeRequest(url);
    };

    static show = (id_mansione) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/mansioni/show`;
            ApiService.postRequest(resolve, reject, url, { id_mansione });
        });
    };

    static create = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/mansioni/create`;
            ApiService.postRequest(resolve, reject, url, data);
        });
    };

    static update = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/mansioni/update`;
            ApiService.putRequest(resolve, reject, url, data);
        });
    };

    static delete = (id_mansione) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/mansioni/delete`;
            ApiService.delete(resolve, reject, url, { id_mansione });
        });
    };
}
